// extracted by mini-css-extract-plugin
export default {"partnerTableHeader":"PartnerPageTable_partnerTableHeader__JNyyZ","bodyScroll":"PartnerPageTable_bodyScroll__GoQZv","bttmGap":"PartnerPageTable_bttmGap__cIOSG"};